import {SuiteUser} from './SuiteUser';
import {IResident} from '../api-response/building/resident';
import {ISuiteUser} from '../api-response/building/suite-user';
import {UserPhoneType} from './UserPhoneType';
import {IUserPhone} from '../api-response/building/user-phone';

export class ResidentForSelect {
    private suiteToSuiteUsersMap = new Map<string, SuiteUser>();
    private primaryPhone: UserPhoneType;
    private mobilePhones: UserPhoneType[];

    static fromResidentInterface(resident: IResident): ResidentForSelect {
        let suiteUsers: SuiteUser[] = [];
        let phones: UserPhoneType[] = [];
        const suiteUsersMap = new Map();
        if (resident.suiteUser && resident.suiteUser.length > 0 && typeof resident.suiteUser[0] === 'object') {
            suiteUsers = (resident.suiteUser as ISuiteUser[])
                .map(suiteUser => {
                    const suiteUserInstance = new SuiteUser(suiteUser.id, suiteUser.role, `${suiteUser.suite}`, suiteUser.user);
                    suiteUsersMap.set(`${suiteUser.suite}`, suiteUserInstance);
                    return suiteUserInstance;
                });
        }
        if (resident.phones && resident.phones.length > 0 && typeof resident.phones[0] === 'object') {
            phones = (resident.phones as IUserPhone[]).map(UserPhoneType.fromUserPhone);
        }
        const selectResident = new ResidentForSelect(
            resident.id,
            resident.fullName,
            suiteUsers,
            resident.email,
            Boolean(resident.isValidEmail),
            Boolean(resident.parcelWaiverSigned),
            phones
        );
        selectResident.suiteToSuiteUsersMap = suiteUsersMap;
        return selectResident;
    }

    constructor(
        public id: number,
        public fullName: string,
        public suiteUsers: Array<SuiteUser> = [],
        public email: string = '',
        public isValidEmail: boolean = false,
        public parcelWaiverSigned: boolean = false,
        public phones: UserPhoneType[] = []
    ) {
    }

    getSuiteUserBySuite(suite: string) {
        return this.suiteToSuiteUsersMap.get(suite);
    }

    getPrimaryPhone(): string {
        if (this.primaryPhone) {
            return this.primaryPhone.phone;
        }
        if (!this.phones || this.phones.length < 1) {
            return '';
        }
        this.primaryPhone = this.phones.filter((phone: UserPhoneType) => phone.isPrimaryPhone)[0];
        if (!this.primaryPhone) {
            this.primaryPhone = this.phones[0];
        }
        return this.primaryPhone.phone;
    }

    getMobilePhone() {
        if (this.mobilePhones && this.mobilePhones.length > 0) {
            return this.mobilePhones[0].phone;
        }
        if (!this.phones || this.phones.length < 1) {
            return undefined;
        }
        this.mobilePhones = this.phones.filter(p => p.phoneType == 'phone_cell' && p.realPhoneType == 'phone_cell');
        if (!this.mobilePhones || this.mobilePhones.length === 0) {
            return '';
        }
        return this.mobilePhones[0].phone;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ResidentForSelect.ts